// extracted by mini-css-extract-plugin
export default {"container":"Inputcontrol_container__D4x5t"};